<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ file ? 'Update' : 'Add' }} Link
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Link Name">
          <d-input v-model="form.name" required />
        </d-field>
        <d-field v-if="ContentListingType.STATIC === contentListing.type" label="Link URL">
          <d-input v-model="form.url" required />
        </d-field>
        <d-field v-else label="Link URL">
          <d-input v-model="form.content" required />
        </d-field>
        <d-field label="Description">
          <l-html-editor v-model="form.description" />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$emit('close')">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          {{ file ? 'Update' : 'Add' }} Link
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import { createItem, updateItem } from '@resources/scripts/services/contentListingItemsApi.service';
  import { ListingItemType, ContentListingType } from '@resources/scripts/constants';
  import { showErrorToast } from '@services/errorHandling.service';

  export default {
    props: {
      contentListing: {
        type: Object,
        default: () => ({}),
      },
      file: {
        type: Object,
        default: null,
      },
    },

    emits: ['close', 'saved'],

    data() {
      return {
        ContentListingType,
        saving: false,
        form: {
          name: '',
          url: '',
          content: '',
          description: '',
          categorized: true,
          type: ListingItemType.LINK,
        },
      };
    },

    mounted() {
      if (this.file) {
        this.form = JSON.parse(JSON.stringify(this.file));
      }
    },

    methods: {
      async saveForm() {
        this.saving = true;
        try {
          if (this.file) {
            await updateItem(this.form.id, this.form, this.contentListing.type);
          } else {
            await createItem(this.form, this.contentListing.id, this.contentListing.type);
          }
          this.$emit('saved');
          this.$emit('close');
        } catch (error) {
          showErrorToast(error);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>